import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ElementUI from "element-ui";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "element-ui/lib/theme-chalk/index.css";

import "swiper/css/swiper.css"; // 导入样式

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js